
<section class="service-item-section">
  <ion-header>
    <app-header-small title="Checkout" [showLocationModal]="true"></app-header-small>
  </ion-header>
  <div class="product-content">
    <div *ngIf="isLoad; then content else spinner"></div>

    <ng-template #content>
      <div class="product-container">
        <ng-container *ngTemplateOutlet="cardHeader"></ng-container>
        <ng-container *ngTemplateOutlet="cardBody"></ng-container>
        <ng-container *ngTemplateOutlet="cardFooter"></ng-container>
      </div>
    </ng-template>

    <ng-template #spinner>
      <div class="spinner-wrapper">
        <app-spinner></app-spinner>
      </div>
    </ng-template>
  </div>
</section>

<ng-template #cardHeader>
  <div class="product-container__header"
       [class.product-container__header-image-enlarged]="enlargedImages">
    <app-product-details
      [product]="product"
      [chosenVariation]="chosenVariation"
      [hasAllBorderRadius]="true"
      [truncateLength]="truncateDescriptionLength"
      [hoursOfOperation]="hoursOfOperation"
      [currencySign]="currencySign"
      [enlargedImage]="restaurant?.enlargeProductImages"
      [hidePrice]="true"
      [restaurant]="restaurant"
    >
    </app-product-details>
  </div>
</ng-template>

<ng-template #cardBody>
  <div class="product-container__body"
       [class.product-container__body-image-enlarged]="enlargedImages"
       [class.product-card-container-image-enlarged]="enlargedImages">
    <div class="product-container__body-variations" *ngIf="!isOnlyOneVariation">
      <div class="product-container__body-group-title">
        Choose variation - <span class="product-container__body-group-title-required-status">Required</span>
        <span class="product-container__body-group-title-error-status">&#160;{{variationsInvalidMessage}}</span>
      </div>
      <form>
        <ion-list lines="none" class="product-container__body-list">
          <ion-radio-group>
            <ion-item class="product-container__body-list-item" no-lines
                      *ngFor="let variation of product.variations; index as i">
              <ion-label
                class="product-container__body-list-item-label"
                [color]="isActiveVariation(variation) ? 'brand' : 'main-dark'">
                {{cleanedName(variation.name)}}
                <span>({{currencySign}}{{getFormattedPrice(variation.price.formattedAmount)}})</span>
                <span class="product-container__body-list-item-unavailable" *ngIf="isApplyVariationInStock(variation)">&nbsp;&nbsp;UNAVAILABLE</span>
              </ion-label>
              <ion-radio [value]="variation"
                         [checked]="isActiveVariation(variation)"
                         (ionSelect)="chooseVariation($event.target.value)"
                         mode="md"
                         slot="start"
                         color="brand"
                         class="product-container__body-list-item-radio">
              </ion-radio>
            </ion-item>
          </ion-radio-group>
        </ion-list>
      </form>
    </div>
    <!-- ============ MODIFIERS =========== -->
    <div class="product-container__body-modifiers"
         *ngFor="let modifierGroup of product.modifierGroups; index as modifiersListIndex"
         [hidden]="isModifiersHidden(modifierGroup.modifiers)">
      <div class="product-container__body-group-title" id="modifier {{modifierGroup.id}}">
        {{cleanedName(modifierGroup.name)}} - <span class="product-container__body-group-title-required-status">{{formatModifierGroupRequiredStatus(modifierGroup)}}</span>
        <span class="product-container__body-group-title-error-status" *ngIf="!validateItemModifiers(modifierGroup) && showInvalid">&#160;(please select a valid option)</span>
      </div>
      <div *ngIf="modifierGroup.selectionType === 'MULTIPLE' && !isSelectOneModifier(modifierGroup)">
        <ion-list lines="none" class="product-container__body-list">
          <ion-item class="product-container__body-list-item"
                    *ngFor="let modifier of modifierGroup.modifiers; index as modifierIndex"
                    [hidden]="!modifier.isShow">
            <ion-label
              class="product-container__body-list-item-label"
              [color]="isChosenModifier(modifiersListIndex, modifierIndex) ? 'brand' : 'main-dark'">
              {{cleanedName(modifier.name)}}
              <span *ngIf="modifier.price.formattedAmount > 0">
                  (+ {{currencySign}}{{getFormattedPrice(findModifierPrice(modifier))}})
                </span>
            </ion-label>
            <ion-checkbox
              class="product-container__body-list-item-checkbox"
              color="brand"
              slot="start"
              mode="md"
              [checked]="isChosenModifier(modifiersListIndex, modifierIndex)"
              (ionChange)="chooseModifier($event, modifiersListIndex, modifierIndex)">
            </ion-checkbox>
            <div class="slider" *ngIf="formatDataService.containsKeyword(modifier.name, 'SLIDER')">
              <mat-slider [disabled]="!isChosenModifier(modifiersListIndex, modifierIndex)" min="1" max="3" step="1" value="2" (input)="modifierSliderChoose($event.value, modifiersListIndex, modifierIndex)"></mat-slider>
              <span class="slider__param">{{isChosenModifier(modifiersListIndex, modifierIndex) ? findModifierSliderParam(modifier) : ""}}</span>
            </div>
          </ion-item>
        </ion-list>
      </div>
      <div *ngIf="isSelectOneModifier(modifierGroup)">
        <ion-list lines="none" class="product-container__body-list">
          <ion-radio-group>
            <ion-item class="product-container__body-list-item" no-lines
                      *ngFor="let modifier of modifierGroup.modifiers; index as modifierIndex"
                      [hidden]="!modifier.isShow">
              <ion-label
                class="product-container__body-list-item-label"
                [color]="isChosenModifier(modifiersListIndex, modifierIndex) ? 'brand' : 'main-dark'">
                {{cleanedName(modifier.name)}}
                <span *ngIf="modifier.price.formattedAmount > 0">
                    (+ {{currencySign}}{{getFormattedPrice(findModifierPrice(modifier))}})</span>
              </ion-label>
              <ion-radio
                class="product-container__body-list-item-radio"
                color="brand"
                slot="start"
                mode="md"
                [checked]="isChosenModifier(modifiersListIndex, modifierIndex)"
                (ionSelect)="chooseAndRemoveModifiers($event, modifiersListIndex, modifierIndex)">
              </ion-radio>
              <div class="slider" *ngIf="formatDataService.containsKeyword(modifier.name, 'SLIDER')">
                <mat-slider [disabled]="!isChosenModifier(modifiersListIndex, modifierIndex)"
                            min="1" max="3" step="1" value="2"
                            (input)="modifierSliderChoose($event.value, modifiersListIndex, modifierIndex)">
                </mat-slider>
                <span class="slider__param">{{isChosenModifier(modifiersListIndex, modifierIndex) ? findModifierSliderParam(modifier) : ""}}</span>
              </div>
            </ion-item>
          </ion-radio-group>
        </ion-list>
      </div>
    </div>
  </div>
</ng-template>

<!-- ============ FOOTER TEMPLATE =========== -->
<ng-template #cardFooter>
  <div class="item-service-footer">
    <div class="checkout-btns">
      <ion-button (click)="goToCheckoutPage()"
                  [disabled]="isAddButtonDisabled(product)"
                  class="checkout-btns__btn" color="brand" expand="block">
        Continue
      </ion-button>
      <p class="checkout-btns__error"></p>
      <ion-button (click)="cancel()" fill="clear" class="checkout-btns__btn checkout-btns__cancel-btn cancel" expand="block">
        Cancel order
      </ion-button>
    </div>
  </div>
</ng-template>
